export const canvasSidebarToggleActiveClassName =
  "bg-violet-200 text-violet-800 hover:bg-violet-200 hover:text-violet-800 focus-visible:bg-violet-200 dark:bg-violet-200 dark:text-violet-800 dark:hover:bg-violet-200 dark:hover:text-violet-800 dark:focus-visible:bg-violet-200";

export const canvasSidebarToggleInactiveClassName =
  "bg-slate-100 text-slate-500 hover:bg-slate-100 hover:text-foreground focus-visible:bg-slate-100 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus-visible:bg-gray-700";
